// extracted by mini-css-extract-plugin
export default {"root":"Status_root__F7hk4","completed":"Status_completed__RhXV1","rejected":"Status_rejected__cEkx5","error":"Status_error__H+zdC"};